import { render } from "./info-window.vue?vue&type=template&id=2f85388c"
import script from "./info-window.vue?vue&type=script&lang=js"
export * from "./info-window.vue?vue&type=script&lang=js"

import exportComponent from "/home/smartbees/Desktop/stare pliki/smartbees/Documents/projects/link/web/modules/custom/link4_agent/content_search_vue_map/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__